class AvisAssociation extends HTMLElement {
    constructor() {
        super();

        this.avisResultContainer = this.querySelector('[data-avis-result]');
        this.avisSearchContainer = this.querySelector('[data-avis-search]');

        this.avisPrivateRestriction = window.themeVariables.avisRestrictions.private_restriction || false;

        this.avisCheckoutInfos = this.querySelector('[data-avis-checkout-infos]');

        // this.avisSelect = this.querySelector('[data-avis-select]');
        // this.avisOptions = this.avisSelect.querySelectorAll('option');
        this.avisRemove = this.querySelector('[data-avis-remove]');

        this.isBuyingValid = false;
        this.isCondolenceValid = false;
        this.selectedElementData = null;

        this.avisResultImage = this.querySelector('[data-avis-image]');
        this.avisResultName = this.querySelector('[data-avis-name]');
        this.avisResultDate = this.querySelector('[data-avis-date]');
        this.avisResultMessage = this.querySelector('[data-avis-message]');
        this.avisResultAdditionnalMessage = this.querySelector('[data-avis-additionnal-message]');

        this.avisMessage = this.querySelector('[data-avis-message]');

        // hijack predictive search link click
        this.predictiveSearchResults = this.querySelector(
            '[data-custom-predictive-search]'
        );

        this.init();
    }

    connectedCallback() {

        // add event listeners
        // this.avisSelect.addEventListener('change', this.handleAvisSelectChange.bind(this));
        this.avisRemove.addEventListener('click', this.handleAvisRemoveClick.bind(this));
        this.avisMessage.addEventListener('keyup', this.handleAvisMessageChange.bind(this));

        this.predictiveSearchResults.addEventListener('click', this.handlePredictiveAvisSelect.bind(this));

        // event listener for avis reload
        document.addEventListener('avis:reload', this.reloadAvisAssociation.bind(this));
        document.addEventListener('avis:selected', this.reloadAvisAssociation.bind(this));
    }

    disconnectedCallback() {

        // remove event listeners
        // this.avisSelect.removeEventListener('change', this.handleAvisSelectChange.bind(this));
        this.avisRemove.removeEventListener('click', this.handleAvisRemoveClick.bind(this));
        this.avisMessage.removeEventListener('keyup', this.handleAvisMessageChange.bind(this));

        this.predictiveSearchResults.removeEventListener('click', this.handlePredictiveAvisSelect.bind(this));
    }

    init() {
        // console.log('AvisAssociation init');

        // get selected element data from session storage
        this.selectedElementData = JSON.parse(sessionStorage.getItem('avisDataProduct'));

        // load only when selected element data is found
        if (this.selectedElementData !== null) {
            // load avis result container
            this.updateAvisResultContent();
        }

        // toggle avis result container
        this.toggleAvisResultContainer();

        // manage avis checkout infos
        this.manageAvisCheckoutInfos();

        this.classList.remove('section-loading');
    }

    reloadAvisAssociation(event) {
        // console.log('AvisAssociation reloadAvisAssociation', event);

        document.querySelectorAll('avis-association').forEach(avisAssociation => {
            avisAssociation.init();
        });
    }

    updateAvisResultContent() {

        let resultImage = this.avisResultImage.dataset.placeholder;

        if (this.selectedElementData.contrat && this.selectedElementData.contract !== "") {
            let avisId = this.selectedElementData.contrat;

            const avisData = window.avis.find(avis => `${avis.unique_id}` === `${avisId}`);
            if (avisId && window.avis && avisData && avisData.avis_image) {
                resultImage = avisData ? avisData.avis_image : (window.themeVariables.avisImagePlaceholder ?? window.avisSvg);
            }

            resultImage = this.selectedElementData.image ?? resultImage;
        }

        this.avisResultImage.src = resultImage;
        this.avisResultName.textContent = this.selectedElementData.name;
        this.avisResultDate.textContent = this.selectedElementData.dates;

        this.avisSearchContainer.classList.add('tw-hidden');
        this.avisResultContainer.classList.remove('tw-hidden');
    }

    toggleAvisResultContainer() {
        // apply buying restrictions
        this.handleBuyingRestriction();

        // toggle containers visibility
        if (this.selectedElementData !== null) {
            this.avisSearchContainer.classList.add('tw-hidden');
            this.avisResultContainer.classList.remove('tw-hidden');

            // enable controls clicks
            document.querySelectorAll(".product-form__controls").forEach(control => control.classList.remove("disabled"));

            // enable add-to-cart submit button
            document.querySelectorAll('product-form button[type="submit"]').forEach(submitButton => {
                submitButton.disabled = false;
                submitButton.classList.remove('avis-disabled');
            });
        }
        else {
            console.log("no avis selected")
            this.avisSearchContainer.classList.remove('tw-hidden');
            this.avisResultContainer.classList.add('tw-hidden');

            // disable controls clicks
            document.querySelectorAll(".product-form__controls").forEach(control => control.classList.add("disabled"));

            // disable add-to-cart submit button
            document.querySelectorAll('product-form button[type="submit"]').forEach(submitButton => {
                submitButton.disabled = true;
                submitButton.classList.add('avis-disabled');
            });
        }
    }

    handleAvisSelectChange(event) {
        // console.log('AvisAssociation handleAvisSelectChange', event);

        // get selected element
        const selectedValue = event.target.value;

        if (selectedValue === '') {
            console.log('selectedValue is empty');
            return;
        }

        const selectedElement = Array.from(this.avisOptions).find(option => option.value === selectedValue);

        // get selected element data
        this.selectedElementData = this.extractAvisData(selectedElement);
        sessionStorage.setItem('avisDataProduct', JSON.stringify(this.selectedElementData));

        // load avis result container
        this.updateAvisResultContent();

        // toggle avis result container
        this.toggleAvisResultContainer();

        // manage avis checkout infos
        this.manageAvisCheckoutInfos();

        document.dispatchEvent(new CustomEvent("avis:selected", {
            detail: this.selectedElementData,
            bubbles: true
        }));
    }

    handleBuyingRestriction() {
        // check if the buying is restricted
        if( this.avisPrivateRestriction && this.selectedElementData?.private == 'true' )
            this.isBuyingValid = false;
        else if( this.selectedElementData !== null && this.selectedElementData.expoDay != null && this.selectedElementData.expoHour != null) {
            this.isBuyingValid = window.isAvisHasValidDate(this.selectedElementData.expoDay, this.selectedElementData.expoHour)
                                    && window.isAvisHasValidComplexe(this.selectedElementData.complexe);
            this.isCondolenceValid = window.isAvisHasValidDate(this.selectedElementData.expoDay, this.selectedElementData.expoHour);
            // console.log(this.isCondolenceValid, ' condolence')
        } else {
            this.isBuyingValid = false;
        }

        // handle display
        if (this.selectedElementData !== null && !this.isBuyingValid) {
            console.log('Buying is restricted');

            // add restricted class to avis box
            this.classList.add('isRestricted');
            this.avisResultMessage.setAttribute('disabled', 'disabled');

            // add restricted class to product forms
            document.querySelectorAll('product-form, .product__info-container').forEach(
                productForm => {
                    productForm.classList.add('isRestricted');
                }
            );
        } else {
            console.log('Buying is not restricted');
            // remove restricted class from avis box
            this.classList.remove('isRestricted');
            this.avisResultMessage.removeAttribute('disabled');

            // remove restricted class from product forms
            document.querySelectorAll('product-form, .product__info-container').forEach(
                productForm => {
                    productForm.classList.remove('isRestricted');
                }
            );
        }
    }

    handlePredictiveAvisSelect(event) {
        event.preventDefault();

        const option = event.target;
        if (!option) return;


        // get selected element data
        this.selectedElementData = this.extractAvisData(option);
        sessionStorage.setItem('avisDataProduct', JSON.stringify(this.selectedElementData));

        // load avis result container
        this.updateAvisResultContent();

        // toggle avis result container
        this.toggleAvisResultContainer();

        // manage avis checkout infos
        this.manageAvisCheckoutInfos();

        document.dispatchEvent(new CustomEvent("avis:selected", {
            detail: this.selectedElementData,
            bubbles: true
        }));
    }

    handleAvisMessageChange(event) {
        // console.log('AvisAssociation handleAvisMessageChange', event);

        // get message
        const message = event?.target?.value || '';

        // set message
        // this.avisResultMessage.value = message;
        document.querySelectorAll('[data-checkout-avis-message]').forEach(input => {
            input.value = message;
        });
    }

    extractAvisData(selectedElement) {

        let avisData = {
            contrat: selectedElement.dataset.contrat,
            complexe: selectedElement.dataset.complexe,
            private: selectedElement.dataset.private,
            expoAddress: selectedElement.dataset.address,
            expoDay: selectedElement.dataset.expoday,
            expoHour: selectedElement.dataset.expohour,
            dates: selectedElement.dataset.dates,
            image: selectedElement.dataset.image,
            name: selectedElement.dataset.name
        }

        return avisData;
    }

    manageAvisCheckoutInfos() {

        // Avis contrat
        document.querySelectorAll('[data-checkout-avis-contrat]').forEach(input => {
            input.value = this.selectedElementData?.contrat || '';
        });

        // Avis name
        document.querySelectorAll('[data-checkout-avis-name]').forEach(input => {
            input.value = this.selectedElementData?.name || '';
        });

        // Avis complexe
        document.querySelectorAll('[data-checkout-avis-complexe]').forEach(input => {
            input.value = this.selectedElementData?.complexe || '';
        });

        // Avis address
        document.querySelectorAll('[data-checkout-avis-address]').forEach(input => {
            input.value = this.selectedElementData?.expoAddress || '';
        });

        // Avis day
        document.querySelectorAll('[data-checkout-avis-day]').forEach(input => {
            input.value = this.selectedElementData?.expoDay || '';
        });

        // Avis hour
        document.querySelectorAll('[data-checkout-avis-hour]').forEach(input => {
            input.value = this.selectedElementData?.expoHour || '';
        });

    }

    handleAvisRemoveClick(event = null) {
        // clear session storage
        sessionStorage.removeItem('avisDataProduct');

        // clear selected element data
        this.selectedElementData = null;

        // toggle avis result container
        this.toggleAvisResultContainer();

        // manage avis checkout infos
        this.manageAvisCheckoutInfos();

        // dispatch event
        if (event !== null) {
            document.dispatchEvent(new Event('avis:reload'), {
                detail: this,
                bubbles: true
            });
        }
    }
}

if (!customElements.get('avis-association')) {
    customElements.define('avis-association', AvisAssociation);
}